import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Box, Flex, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {ErrorIcon} from '../icons/index'

export const FewItemsLeftIcon = ({isLarge, variant, ...props}) => {
    const styles = useMultiStyleConfig('FewItemsLeft', {isLarge, variant})

    return <Box as="span" {...styles.icon} {...props} />
}

export const FewItemsLeftMessage = ({containerProps = {}, textProps = {}, message}) => (
    <FewItemsLeftMessageContent containerProps={containerProps} textProps={textProps} message={message} />
)

const FewItemsLeftMessageContent = ({containerProps = {}, textProps = {}, message}) => {
    const styles = useMultiStyleConfig('FewItemsLeft')

    return (
        <Flex data-testid="few-items-left-message" {...styles.container} {...containerProps}>
            <ErrorIcon {...styles.errorIcon} />
            <Text {...styles.text} {...textProps}>
                {message ?? <FormattedMessage id="product.few_left" defaultMessage="Few Left" />}
            </Text>
        </Flex>
    )
}

FewItemsLeftMessage.propTypes = {
    containerProps: PropTypes.object,
    textProps: PropTypes.object,
    message: PropTypes.node
}

FewItemsLeftMessageContent.propTypes = {
    containerProps: PropTypes.object,
    textProps: PropTypes.object,
    message: PropTypes.node
}
